import useSWR from 'swr'
import { Single_Book } from '@graphql/queries'

const useSingleBook = (id) => {
  const { data, error, mutate, isValidating } = useSWR([Single_Book, id])
  const book = data?.book ? data?.book : null

  return {
    book,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSingleBook }
